// extracted by mini-css-extract-plugin
module.exports = {"benefitFormSection":"BenefitsForm_benefitFormSection__Fxjbu","container":"BenefitsForm_container__cJtvC","formWrapper":"BenefitsForm_formWrapper__o0vLJ"};